// extracted by mini-css-extract-plugin
module.exports = {"indicator":"ApiUseNotification_indicator__1up9p"};